export enum EUserInboxQueryKey {
  USER_INBOX_LIST_MESSAGES = 'user-inbox-list-messages',
  USER_INBOX_MARK_AS_READ = 'user-inbox-mark-as-read',
  USER_INBOX_MARK_ALL_AS_READ = 'user-inbox-mark-all-as-read',
}
